import React, { useMemo, useState } from "react";
import * as Scrivito from "scrivito";
import { Button, TranslateWrapper } from "components";
import { UncontrolledTooltip } from "reactstrap";
import cx from "classnames";
import { useTranslate } from "hooks";

import { useTopology } from "objs/_ConfiguratorObjs/Wizard/stores/wizardStore";
import s from "../wizardLeftSidebar.module.scss";

export const WizardLeftSidebarSystemInfo = Scrivito.connect(() => {
  const translate = useTranslate();
  const topology = useTopology();
  if (!topology[0]?.summary?.items) {
    return null;
  }

  const [isVisible, setIsVisible] = useState(true);

  const toggleSiVisible = () => setIsVisible((prev) => !prev);

  const isDummyInside = useMemo(() => {
    let dummyCount = 0;
    topology[0]?.summary?.items?.forEach?.((item) => {
      if (item.isDummy) {
        dummyCount += item.quantity;
      }
    });
    return dummyCount !== 0;
  }, [topology]);

  if (!topology[0]?.summary?.items) {
    return null;
  }

  return (
    <div className={cx(s.systemInformation, "px-4 mt-4")}>
      {topology[0].summary && (
        <>
          <div className="d-flex align-content-center gap-2 mb-2_5">
            <h5 className={cx(s.systemInformationTitle, "mb-0")}>
              {topology[0].summary.title}
            </h5>
            <Button
              data-testid="systemInformationEyeIcon"
              square={true}
              outline
              iconPrefix="trox"
              icon={isVisible ? "eye-slash-light" : "eye-light"}
              iconClassName="icon-16"
              classNames={cx(
                "p-0 border-0 px-2 cursor-pointer",
                isDummyInside ? "text-warning" : "text-white",
              )}
              id="systemInformationEyeIcon"
              onClick={toggleSiVisible}
            />
            <UncontrolledTooltip
              target="systemInformationEyeIcon"
              placement="top"
            >
              {isVisible
                ? translate("HIDE_SYSTEM_INFORMATION")
                : translate("SHOW_SYSTEM_INFORMATION")}
            </UncontrolledTooltip>
            {typeof translate("SHOW_SYSTEM_INFORMATION") === "object" && (
              <TranslateWrapper
                tooltipId="systemInformationEyeIcon"
                tooltipText={
                  isVisible
                    ? "HIDE_SYSTEM_INFORMATION"
                    : "SHOW_SYSTEM_INFORMATION"
                }
                placement="right"
              />
            )}
          </div>
          <div
            className={cx(s.systemInformationContent, {
              [s.systemInformationContentOpened]: isVisible,
            })}
          >
            <div className="d-flex flex-column">
              {topology[0]?.summary?.items?.length > 0
                ? topology[0].summary.items.map(
                    ({ title, quantity, isDummy }) => (
                      <p className="mb-2" key={title}>
                        <span className={cx({ "text-warning": isDummy })}>
                          {title}
                        </span>
                        &nbsp;
                        {quantity}
                      </p>
                    ),
                  )
                : translate("NO_DATA")}
            </div>
          </div>
        </>
      )}
    </div>
  );
});
